import React from "react";
import {
  Modal,
  Stack,
  Text,
  Button,
  Group,
  ActionIcon,
  Box,
} from "@mantine/core";
import { IconX, IconRocket } from "@tabler/icons-react";
import Logo from "../../common/Logo/Logo";

interface WebsitePublishSuccessModalProps {
  opened: boolean;
  onClose: () => void;
}

const WebsitePublishSuccessModal: React.FC<WebsitePublishSuccessModalProps> = ({
  opened,
  onClose,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      fullScreen
      withCloseButton={false}
      padding={0}
      styles={{
        body: {
          height: "100%",
          padding: 0,
        },
        content: {
          height: "100%",
        },
      }}
    >
      <Box
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          background: `
            linear-gradient(180deg, 
              rgba(255, 255, 255, 1) 0%, 
              rgba(255, 255, 255, 1) 60%,
              rgba(255, 255, 255, 0.95) 75%,
              rgba(255, 255, 255, 0.9) 100%
            ),
            radial-gradient(ellipse at 20% 100%, rgba(162, 213, 94, 0.25) 0%, transparent 50%),
            radial-gradient(ellipse at 50% 100%, rgba(54, 175, 201, 0.2) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 100%, rgba(222, 133, 78, 0.2) 0%, transparent 50%)
          `,
          backgroundColor: "#ffffff",
        }}
      >
        {/* Header with close button and logo */}
        <Group justify="space-between" p="lg" style={{ width: "100%" }}>
          <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            onClick={onClose}
            aria-label="Close"
          >
            <IconX size={24} />
          </ActionIcon>
          <Logo variant="horizontal" size="sm" />
        </Group>

        {/* Main content - centered */}
        <Stack
          align="center"
          justify="center"
          gap="lg"
          style={{
            flex: 1,
            padding: "2rem",
          }}
        >
          {/* Rocket icon */}
          <Box
            style={{
              color: "#36AFC9",
              marginBottom: "0.5rem",
            }}
          >
            <IconRocket size={48} stroke={1.5} />
          </Box>

          {/* Heading */}
          <Text
            fw={700}
            size="xl"
            style={{
              fontSize: "2rem",
              color: "#101820",
              textAlign: "center",
            }}
          >
            Website published!
          </Text>

          {/* Subtitle */}
          <Text
            c="dimmed"
            size="md"
            style={{
              textAlign: "center",
              maxWidth: "400px",
            }}
          >
            Visit{" "}
            <Text
              component="span"
              c="teal"
              fw={500}
              style={{ cursor: "pointer" }}
              onClick={() => {
                onClose();
                // Navigation happens via onClose callback
              }}
            >
              Settings
            </Text>{" "}
            if you want to make changes to your site.
          </Text>

          {/* Continue button */}
          <Button
            color="teal"
            size="md"
            radius="xl"
            mt="md"
            onClick={onClose}
            style={{
              paddingLeft: "2rem",
              paddingRight: "2rem",
            }}
          >
            Continue
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default WebsitePublishSuccessModal;
